import React from 'react';
import BaseField from '../BaseField/BaseField';
import { RangeIcon } from 'assests/GmsIcons';

interface RangeFieldProps {
  id?: string;
  title?: string;
  label?: string;
  displayName?: string;
  showTitle?: boolean;
  min?: number;
  max?: number;
  step?: number;
  value?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  isSelected?: boolean;
  exclusionType?: 'hide' | 'disable';
}

const RangeField = ({ id = 'range-field', title = 'Title', label = 'Range Field', displayName, showTitle = true, min = 0, max = 100, step = 1, value = 50, onChange = () => {}, disabled = false, isSelected = false, exclusionType = 'hide' }: RangeFieldProps) => {
  const baseId = id || 'range-field';

  const displayLabel = showTitle && displayName ? displayName : (showTitle ? label : '');

  return (
    <BaseField
      id={baseId}
      label={displayLabel}
      isSelected={isSelected}
      showTitle={showTitle}
    >
      <div id={`${baseId}-icon-container`} className="tw-w-full tw-ps-4">
        <RangeIcon />
      </div>
    </BaseField>
  );
};

export default RangeField;